import { Controller } from "@hotwired/stimulus"

export default class ExampleController extends Controller {
  connect() {
    console.log("Hello, Stimulus!", this.element)
    this.element.style.backgroundColor = 'red';
  }
}
